// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Provider } from 'mobx-react';
import { Layout } from './layout';
import ReactDOM from 'react-dom';
import { MainContainer } from './style';
import GlobalStyle from './global.style';
import { init } from './libs/i18n/i18n';
import { TransporProvider } from './providers/transport-provider';
const createReactUI = (rootStore) => {
    let layoutDiv = null;
    const render = (transport) => {
        ReactDOM.render(React.createElement(TransporProvider, { value: transport },
            React.createElement(Provider, { ...rootStore },
                React.createElement(GlobalStyle, null),
                React.createElement(MainContainer, null,
                    React.createElement(Layout, null)))), layoutDiv);
    };
    if (!document.getElementById('root-app_iframe')) {
        // ROOT APP CONTAINER
        const rootDiv = document.createElement('div');
        const rootDivContent = document.createElement('div');
        rootDivContent.setAttribute('id', 'root-app_side_content');
        // LAYOUT CONTAINER
        layoutDiv = document.createElement('div');
        // DOM APPEND
        rootStore.ui.mfeStage.setAttribute('id', 'root-app_iframe');
        rootDivContent.appendChild(rootStore.ui.mfeStage);
        rootDiv.appendChild(layoutDiv);
        rootDiv.appendChild(rootDivContent);
        document.body.appendChild(rootDiv);
    }
    init();
    return { render };
};
export { createReactUI };
//# sourceMappingURL=react-ui.js.map